import { render, staticRenderFns } from "./personAction.vue?vue&type=template&id=26a0bf56&scoped=true&"
import script from "./personAction.vue?vue&type=script&lang=js&"
export * from "./personAction.vue?vue&type=script&lang=js&"
import style0 from "./personAction.vue?vue&type=style&index=0&id=26a0bf56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a0bf56",
  null
  
)

export default component.exports